import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, FormControl, Validators, FormArray } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-add-enquiry',
  templateUrl: './add-enquiry.component.html',
  styleUrls: ['./add-enquiry.component.scss']
})
export class AddEnquiryComponent implements OnInit {

  @Input() caseId: number;

  enquiryDetails = this.fb.group({
    caseId: null,
    enquiry: '',
    receivedDate: new Date().toISOString().split('T')[0] // Convert to YYYY-MM-DD
  });

  dateReceivedDefaultValue?: Date;

  constructor(
    public activeModal: NgbActiveModal,
    private fb: UntypedFormBuilder,
  ) {
   
  }

  ngOnInit(): void {
    this.enquiryDetails.controls["caseId"].setValue(this.caseId);
  }

  close() {
    this.activeModal.dismiss(null);
  }

  save() {
    this.activeModal.close(this.enquiryDetails.value);
  }

  onDateReceivedChange(event: any) {
    this.enquiryDetails.controls['receivedDate'].setValue(event.target.value);
  }

 

}
